module.exports = __webpack_public_path__ + "static/img/about_bg_05_zh.93ca40e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_bg_05_zh.png
// module id = choC
// module chunks = 34